<template>
  <menu class="navigation-top">
    <ul class="navigation-top__list">
      <router-link to="/portfolio" class="navigation-top__item">Portfolio</router-link>
      <router-link to="/resources" class="navigation-top__item">Resources</router-link>
      <router-link to="/freebies" class="navigation-top__item">Freebies</router-link>

      <router-link to="/" class="navigation-top__lang">
        <p>Fr</p>
      </router-link>
    </ul>

    <div class="navigation-top__burger" @click="$emit('toggle-sidenav')">
      <svg-icon id="menu" />
    </div>
  </menu>
</template>

<script>
export default {
  name: 'NavigationTop',
  data() {
    return {
      links: [
        { name: 'home', label: 'User Interfaces' },
      ]
    }
  }
}
</script>
